import React from 'react';
import { Link } from "react-router-dom";
import * as URL from '../../router/url';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";

function Header() {
    const location = useLocation();

    const handleClick = () => {
        window.scrollTo(0,0);
    }

    const { pathname } = location;

    return (
        <footer className={
            'footer'
            + ' ' + ((pathname === URL.ROOT) ? '-home' : '')
        }>
            <div className="container has-text-white">
                <div className="columns">
                    <div className="column">
                        <nav className='footer-nav'>
                            <Link to={URL.ROOT} onClick={handleClick}>
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname === URL.ROOT }
                                        )
                                    }    
                                >
                                    Главная
                                </div>
                            </Link>
                            <Link to={URL.COMMISSIONING_WORKS} onClick={handleClick}>
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname === URL.COMMISSIONING_WORKS }
                                        )
                                    }    
                                >
                                    Пусконаладочные работы
                                </div>
                            </Link>
                            <Link to={URL.AUTOMATION} onClick={handleClick}>
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname === URL.AUTOMATION }
                                        )
                                    }    
                                >
                                    Автоматизация
                                </div>
                            </Link>
                            <Link to={URL.ABOUT} onClick={handleClick}>   
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname === URL.ABOUT }
                                        )
                                    }    
                                >
                                    О компании
                                </div>
                            </Link>
                            <Link to={URL.PROJECTS} onClick={handleClick}>   
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname?.split('/')[1] === URL.PROJECTS.split('/')[1] }
                                        )
                                    }    
                                >
                                    Проекты
                                </div>
                            </Link>
                            <Link to={URL.VACANCIES} onClick={handleClick}>   
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname?.split('/')[1] === URL.VACANCIES.split('/')[1] }
                                        )
                                    }    
                                >
                                    Вакансии
                                </div>
                            </Link>
                            <Link to={URL.CONTACTS} onClick={handleClick}>   
                                <div 
                                    className={
                                        classNames(
                                            'footer-nav-item',
                                            { current: pathname === URL.CONTACTS }
                                        )
                                    }    
                                >
                                    Контакты
                                </div>
                            </Link>
                        </nav>
                    </div>
                    <div className="column">
                        <div className="block">
                            <p>Россия, 117292, г. Москва, ул. Кедрова, д. 4, корп. 2, пом. V комната 9</p>
                            <p>E-mail:&nbsp;<a href="mailto:info@rgasunaladka.ru">info@rgasunaladka.ru</a></p>
                            <p>Телефон:&nbsp;<a href="tel:+7 (495) 957-12-20">+7 (495) 957-12-20</a></p>
                        </div>
                        <div className="block">
                            ООО «РГ-АСУ-НАЛАДКА» ©&nbsp;2022
                        </div>
                    </div>
                </div>
            </div>
        </footer>        
    )
}

export default Header;